/**
 * GTM + PostHog (PostHog loaded on demand — keeps main and auth bundles smaller).
 */

const AI_REFERRER_DOMAINS = [
  "perplexity.ai", "chat.openai.com", "chatgpt.com",
  "you.com", "phind.com", "copilot.microsoft.com", "gemini.google.com"
]

let aiReferrerDomain = null
try {
  if (document.referrer) {
    const referrerHost = new URL(document.referrer).hostname
    if (AI_REFERRER_DOMAINS.some(d => referrerHost === d || referrerHost.endsWith("." + d))) {
      aiReferrerDomain = referrerHost
    }
  }
} catch (_) { /* invalid referrer */ }

const apiKey = document.querySelector('meta[name="posthog-key"]')?.content
const userId = document.querySelector('meta[name="posthog-user-id"]')?.content
const userEmail = document.querySelector('meta[name="posthog-user-email"]')?.content
const userPlan = document.querySelector('meta[name="posthog-user-plan"]')?.content
const accountId = document.querySelector('meta[name="posthog-account-id"]')?.content

const gtagId = document.querySelector('meta[name="gtag-id"]')?.content

function cookieConsent() {
  return document.cookie.split("; ").find(c => c.startsWith("cookie_consent="))?.split("=")[1]
}

let posthogInitPromise = null

function initGtag() {
  if (!gtagId || cookieConsent() !== "accepted") return
  if (window.__gtagLoaded) return
  window.__gtagLoaded = true

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function() { window.dataLayer.push(arguments) }
  window.gtag("js", new Date())
  window.gtag("config", gtagId)

  document.addEventListener("turbo:load", () => {
    window.gtag("event", "page_view", { page_location: window.location.href })
  })
}

function initPostHog() {
  if (!apiKey || cookieConsent() !== "accepted") return
  if (posthogInitPromise) return posthogInitPromise

  posthogInitPromise = import("posthog-js").then(({ default: posthog }) => {
    if (posthog.__loaded) return posthog

    posthog.init(apiKey, {
      api_host: "https://us.i.posthog.com",
      autocapture: true,
      capture_pageview: false,
      persistence: "localStorage+cookie",
    })

    if (userId) {
      posthog.identify(userId, {
        email: userEmail,
        plan: userPlan,
        account_id: accountId,
      })
    }

    if (aiReferrerDomain) {
      posthog.capture("ai_referral_session", { referrer_domain: aiReferrerDomain })
      posthog.people.set({ last_ai_referral_source: aiReferrerDomain })
    }

    document.addEventListener("turbo:load", () => {
      posthog.capture("$pageview", { url: window.location.href })
    })

    window.posthog = posthog
    return posthog
  }).catch(() => {
    posthogInitPromise = null
  })

  return posthogInitPromise
}

/**
 * Wire analytics once per page load (main app + auth bundles).
 */
export function initAnalytics() {
  initPostHog()
  initGtag()

  document.addEventListener("cookie-consent:accepted", () => {
    initPostHog()
    initGtag()
  })
}
